/**
 * Encodes an object into a URL-encoded query string.
 * @param parameters - An object where the keys and values are the parameters to encode.
 * @returns A URL-encoded query string.
 */

export const encodeParameters = (parameters: Record<string, any>): string => {
  const queryString = Object.keys(parameters)
    .map(key => {
      const encodedKey = encodeURIComponent(key);
      const encodedValue = encodeURIComponent(parameters[key]);

      return `${encodedKey}=${encodedValue}`;
    })
    .join('&');

  return queryString;
};
